import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CuentaBeneficiario } from '../../../models/cuenta-beneficiario';
import { generalService} from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog } from '@angular/material';
import { Usuario } from '../../../models/usuario';

@Component({
  selector: 'my-beneficiario-detalle',
  styles: [],
  templateUrl: './cuenta-beneficiario-detalle.component.html',
  providers: [generalService]
})

export class BeneficiarioDetalleComponent implements OnInit {
  public beneficiario: CuentaBeneficiario = new CuentaBeneficiario();
  beneficiarioAgregar: FormGroup;
  titulo = "Agregar";
  listaBancos: any[] = [];

  constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService) { 
    this.dataService.guardadoModal=false;
  }

  ngOnInit() {
    this.buildForm();
    this.consultarBancos();
    if(this.dataService.tipoModal == "editar"){
      this.titulo = "Editar";
      this.beneficiario.BENEFICIARY_BACK_ACCOUNT_ID = this.dataService.id;
      this.buscarBeneficiario();
    }
  }

  buscarBeneficiario(){
    this._generalService.metodoCallParams(this.beneficiario, "ReciboPagoComponentes/consultarBeneficiario/").subscribe(
      result => {
        this.beneficiario = JSON.parse(result.replace("[", "").replace("]", ""));          
      },
      error => {
        var errorMsj = <any>error;
        console.log(errorMsj);
      }
    );
  }

  consultarBancos() {
    this._generalService.metodoCall(`ReciboPagoComponentes/ConsultBank/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaBancos = res;
            } else {
                this.listaBancos = [];
            }
        },
        (error) => {
            this.listaBancos = [];
            console.log( error as any);
        }
    );
  }

  buildForm() {
    this.beneficiarioAgregar = this.formBuilder.group({
      NAME: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
      ACCOUNT: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
      RFC: this.formBuilder.control({disabled: true}),
      BANCO: this.formBuilder.control(null, [Validators.required]),
    });

    this.beneficiarioAgregar.controls['RFC'].disable();
  }

  cerrarModal(){
    this.dataService.dialogModal.close();
  }

  onSubmit() {
    let metodo = "ReciboPagoComponentes/InsertarBeneficiario/";
    if (this.dataService.tipoModal == "editar") {
      metodo = "ReciboPagoComponentes/ActualizarBeneficiario/";
    } else {
      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idCompania = usuarioSession.COMPANY_ID;
      this.beneficiario.COMPANY_ID = idCompania;
    }

    this.beneficiario.BANK_ID = this.beneficiarioAgregar.controls["BANCO"].value;
    
    this._generalService.metodoCallParams(this.beneficiario, metodo).subscribe(
        result => {
          this.dataService.guardadoModal=true;
          this.cerrarModal();
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
    ); 
  }

  setRFC(event) {
    if(event) {
        const banco = this.listaBancos.find((element) => element.BANK_ID === event);
        this.beneficiarioAgregar.controls["RFC"].setValue(banco.RFC);
    } else {
        this.beneficiarioAgregar.controls["RFC"].setValue(undefined);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/recibo-pago/cuenta-beneficiario/agregar-editar/cuenta-beneficiario-detalle.component.ts